import { useCallback, useState } from "react";
import { buildCustomerFilterPayload } from "../utils";

export function useCustomerFilters(defaultFilters) {
  const [filters, setFilters] = useState(defaultFilters);
  const [appliedFilters, setAppliedFilters] = useState(() =>
    buildCustomerFilterPayload(defaultFilters)
  );

  const handleApply = useCallback(() => {
    setAppliedFilters(buildCustomerFilterPayload(filters));
  }, [filters]);

  const handleReset = useCallback(() => {
    setFilters(defaultFilters);
    setAppliedFilters(buildCustomerFilterPayload(defaultFilters));
  }, [defaultFilters]);

  return {
    filters,
    setFilters,
    appliedFilters,
    handleApply,
    handleReset,
  };
}
